export const ONBOARDING_GET_PROFILE_SCORE = 'ONBOARDING_GET_PROFILE_SCORE';
export const ONBOARDING_GET_BLOG_SCORE = 'ONBOARDING_GET_BLOG_SCORE';
export const ONBOARDING_GET_INVITE_SCORE = 'ONBOARDING_GET_INVITE_SCORE';